export enum QueueStatus {
  FAILED = -1,
  QUEUED = 1,
  PROCESSING = 2,
  COMPLETED = 3,
}
